// cookie
const cookieUtil = {
    set: (name, value, expires, path, domain, secure) => {
        let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

        if (expires instanceof Date) {
            cookieText = `${cookieText};expires=${expires.toGMTString()}`;
        }
        if (path) {
            cookieText = `${cookieText};path=${path}`;
        }
        if (domain) {
            cookieText = `${cookieText};domain${domain}`;
        }
        if (secure) {
            cookieText = `${cookieText};secure`;
        }
        document.cookie = cookieText;
    },
    get: name => {
        const cookieName = `${encodeURIComponent(name)}=`;
        const cookieStart = document.cookie.indexOf(cookieName);
        let cookieValue = null;

        if (cookieStart > -1) {
            let cookieEnd = document.cookie.indexOf(';', cookieStart);

            if (cookieEnd === -1) {
                cookieEnd = document.cookie.length;
            }
            cookieValue = document.cookie.substring(cookieStart + cookieName.length, cookieEnd);
            cookieValue = decodeURIComponent(cookieValue);
        }

        return cookieValue;
    },
};

// 获取广告的userkey
const userkeyUtil = {
    get: l => {
        const len = l || 32;
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        const charsLen = chars.length;
        let uid = '';

        for (let i = 0; i < len; i++) {
            uid += chars.charAt(Math.floor(Math.random() * charsLen));
        }

        return uid;
    },
    init: () => {
        if (cookieUtil.get('userkey')) {
            return cookieUtil.get('userkey');
        } else {
            const uid = userkeyUtil.get(15);
            const exp = new Date();

            exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
            cookieUtil.set('userkey', uid, exp);

            return uid;
        }
    },
};

export default userkeyUtil;
